import { render, staticRenderFns } from "./CreateFaq.vue?vue&type=template&id=f4c07da2&scoped=true"
import script from "./CreateFaq.vue?vue&type=script&lang=js"
export * from "./CreateFaq.vue?vue&type=script&lang=js"
import style0 from "./CreateFaq.vue?vue&type=style&index=0&id=f4c07da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c07da2",
  null
  
)

export default component.exports